var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccomodation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 151,
    viewBox: "0 0 211 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.344 135.842C210.344 143.682 163.252 150.005 105.185 150.005C47.0915 150.005 0 143.657 0 135.842C0 128.027 47.0915 121.679 105.159 121.679C163.252 121.654 210.344 128.002 210.344 135.842Z",
    fill: "#1E01BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.912 53.6973L26.783 79.9492V135.564H61.912H97.041V79.9492L61.912 53.6973Z",
    fill: "#64CDFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1598 92.2404C42.1598 90.0654 40.3895 88.3203 38.2398 88.3203C36.0647 88.3203 34.3197 90.0907 34.3197 92.2404V102.66H42.1851V92.2404H42.1598Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0465 92.2404C54.0465 90.0654 52.2762 88.3203 50.1265 88.3203C47.9514 88.3203 46.2064 90.0907 46.2064 92.2404V102.66H54.0718V92.2404H54.0465Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2347 123.222C68.2347 119.732 65.4021 116.899 61.912 116.899C58.4219 116.899 55.5893 119.732 55.5893 123.222V135.564H68.2347V123.222Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.041 102.61V79.9239L61.912 53.6973L26.783 79.9492V85.4626C44.0567 85.6649 79.8685 90.7737 97.041 102.61Z",
    fill: "#0AAFEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9853 55.746C76.9853 58.3257 79.0845 60.4248 81.6641 60.4248C84.2438 60.4248 86.3429 58.3257 86.3429 55.746V45.5791H76.9853V55.746Z",
    fill: "#1E01BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6429 92.2409C77.6429 90.0659 75.8725 88.3208 73.7228 88.3208C71.5731 88.3208 69.8027 90.0912 69.8027 92.2409V102.661H77.6429V92.2409Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5296 92.2409C89.5296 90.0659 87.7592 88.3208 85.6095 88.3208C83.4345 88.3208 81.6894 90.0912 81.6894 92.2409V102.661H89.5296V92.2409Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.783 53.0146L22.4583 83.1866H61.912H101.34L97.041 53.0146H26.783Z",
    fill: "#1E01BE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M148.432 2.4834L113.303 24.5117V135.311H148.432H183.536V24.5117L148.432 2.4834Z",
    fill: "#64CDFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.432 2.4834L113.303 24.5117V29.3929C129.565 31.4161 166.439 43.7581 183.561 55.5689V24.5117L148.432 2.4834Z",
    fill: "#0AAFEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.303 0.00488281L108.978 25.3463H148.432H187.86L183.536 0.00488281H113.303Z",
    fill: "#1E01BE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.323 116.671H140.516V135.336H156.323V116.671Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.68 37.4858H120.814V45.3513H128.68V37.4858Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.516 37.4858H132.65V45.3513H140.516V37.4858Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M164.188 37.4858H156.323V45.3513H164.188V37.4858Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.352 37.4858H144.487V45.3513H152.352V37.4858Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M176.024 37.4858H168.159V45.3513H176.024V37.4858Z",
    fill: "#B4E6FD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.68 53.0649H120.814V60.9304H128.68V53.0649Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.516 53.0649H132.65V60.9304H140.516V53.0649Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164.188 53.0649H156.323V60.9304H164.188V53.0649Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.352 53.0649H144.487V60.9304H152.352V53.0649Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M176.024 53.0649H168.159V60.9304H176.024V53.0649Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.68 68.6694H120.814V76.5349H128.68V68.6694Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M140.516 68.6694H132.65V76.5349H140.516V68.6694Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M164.188 68.6694H156.323V76.5349H164.188V68.6694Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M152.352 68.6694H144.487V76.5349H152.352V68.6694Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.024 68.6694H168.159V76.5349H176.024V68.6694Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M128.68 84.2739H120.814V92.1394H128.68V84.2739Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M140.516 84.2739H132.65V92.1394H140.516V84.2739Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M164.188 84.2739H156.323V92.1394H164.188V84.2739Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M152.352 84.2739H144.487V92.1394H152.352V84.2739Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M176.024 84.2739H168.159V92.1394H176.024V84.2739Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.68 99.853H120.814V107.718H128.68V99.853Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.516 99.853H132.65V107.718H140.516V99.853Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M164.188 99.853H156.323V107.718H164.188V99.853Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M152.352 99.853H144.487V107.718H152.352V99.853Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M176.024 99.853H168.159V107.718H176.024V99.853Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M156.323 37.4858V41.937C159.004 42.9992 161.634 44.112 164.188 45.2248V37.4858H156.323Z",
    fill: "#B4E6FD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M144.487 37.4858V37.5617C147.092 38.4722 149.722 39.4079 152.352 40.3943V37.4858H144.487Z",
    fill: "#B4E6FD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6975 88.3208C71.7754 88.3208 70.1821 89.7118 69.828 91.5327C72.4836 92.2156 75.0885 92.9743 77.6176 93.7836V92.2662C77.6429 90.0659 75.8725 88.3208 73.6975 88.3208Z",
    fill: "#B4E6FD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5842 88.3208C83.4092 88.3208 81.6641 90.0912 81.6641 92.2409V95.124C84.4208 96.1104 87.0764 97.1979 89.5296 98.3613V92.2409C89.5296 90.0659 87.7592 88.3208 85.5842 88.3208Z",
    fill: "#B4E6FD"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M104.805 137.41C108.283 137.41 111.103 134.591 111.103 131.113C111.103 127.635 108.283 124.815 104.805 124.815C101.327 124.815 98.5079 127.635 98.5079 131.113C98.5079 134.591 101.327 137.41 104.805 137.41Z",
    fill: "#1E01BE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8933 137.41C96.8042 137.41 99.9747 134.24 99.9747 130.329C99.9747 126.418 96.8042 123.248 92.8933 123.248C88.9823 123.248 85.8118 126.418 85.8118 130.329C85.8118 134.24 88.9823 137.41 92.8933 137.41Z",
    fill: "#1E01BE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M114.719 137.41C118.197 137.41 121.017 134.591 121.017 131.113C121.017 127.635 118.197 124.815 114.719 124.815C111.241 124.815 108.422 127.635 108.422 131.113C108.422 134.591 111.241 137.41 114.719 137.41Z",
    fill: "#1E01BE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M104.805 133.819C109.987 133.819 114.188 129.618 114.188 124.436C114.188 119.254 109.987 115.053 104.805 115.053C99.6232 115.053 95.4224 119.254 95.4224 124.436C95.4224 129.618 99.6232 133.819 104.805 133.819Z",
    fill: "#1E01BE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3895 137.411H114.719V135.311L109.004 132.681H92.7163L90.3895 137.411Z",
    fill: "#1E01BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomodation);
export default __webpack_public_path__ + "static/media/accomodation.d6ec505a0179738c9b69319e2c515591.svg";
export { ForwardRef as ReactComponent };